import { useEffect, useState } from "react";
import {MdEventNote, MdSource} from 'react-icons/md';
import {ImStatsDots} from 'react-icons/im';
import {BiTask,BiPhoneCall} from 'react-icons/bi';

export default function NabarPhone({active, onActive}) {
    const [windowActive, setWindowActive] = useState(active);
    useEffect(() => {
        setWindowActive(active);
    }, [active]);
    return (
        <>
        <div className='bg-white border-t border-gray-200 fixed sm:fixed md:hidden flex flex-row w-full text-fondo justify-between px-3 sm:px-3 md:px-4'
         style={{position:'fixed',bottom:'0px',zIndex:999999 }}
         >
           <p className={`flex flex-col items-center mt-1 py-2 px-2 cursor-pointer rounded-xl text-lg ${windowActive === 'exams'?' text-primary':'text-gray-500'}`} 
           onClick={() => onActive('exams')}
           ><BiTask className='text-2xl'/><span className='text-xs'>Examenes</span></p>
           <p className={`flex flex-col items-center mt-1 py-2 px-2 cursor-pointer rounded-xl text-lg ${windowActive === 'events'?' text-primary':'text-gray-500'}`}
           onClick={() => onActive('events')}
           ><MdEventNote className='text-2xl'/><span className='text-xs'>Eventos</span></p>
           <p className={`flex flex-col items-center mt-1 py-2 px-2 cursor-pointer rounded-xl text-lg ${windowActive === 'history'?' text-primary':'text-gray-500'}`}
           onClick={() => onActive('history')}
           ><ImStatsDots className='text-2xl'/> <span className='text-xs'>Resultados</span> </p>
           <p className={`flex flex-col items-center mt-1 py-2 px-2 cursor-pointer rounded-xl text-lg ${windowActive === 'sources'?' text-primary':'text-gray-500'}`}
           onClick={() => onActive('sources')}
           ><MdSource className='text-2xl'/> <span className='text-xs'>Recursos</span> </p>
           <p className={`flex flex-col items-center mt-1 py-2 px-2 cursor-pointer rounded-xl text-lg ${windowActive === 'contact'?' text-primary':'text-gray-500'}`}
           onClick={() => onActive('contact')}
           ><BiPhoneCall className='text-2xl'/><span className='text-xs'>Soporte</span> </p>
         </div>
       </>
    )
}
